import script from "./AppInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppInfo.vue?vue&type=script&lang=ts&setup=true"

import "./AppInfo.vue?vue&type=style&index=0&id=3c0bc142&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0bc142"]])

export default __exports__